import styled from "styled-components";

export const BannerListContainerStyled = styled.div`
  .btn_create {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    .w120 {
      margin-left: 8px;
      width: 120px;
    }
  }
  .header {
    display: flex;
    flex-direction: column;
    .header_btn {
      display: flex;
      width: 100%;
      justify-content: flex-end;
      .btn_create {
        display: flex;
        flex-direction: column;
        .w120 {
          width: 200px;
          margin-bottom: 10px;
        }
      }
    }
    .input_body {
      padding: 1.25rem;
    }
  }
  .body_table {
    margin-top: 20px;
    border-radius: 1rem;
    padding: 1.25rem 0;
    background: ${({ theme }) => theme.COLORS.WHITE_1};
    .banner_preview_img {
      display: block;
      width: 140px;
      height: 72px;
      border-radius: 6px;
      object-fit: cover;
      cursor: zoom-in;
    }
  }
`;

export const StatusButton = styled.button`
  background-color: ${({ bg }) => bg};
  width: 100%;
  display: flex;
  justify-content: center;
  color: ${({ theme }) => theme.COLORS.WHITE_1};
  border-radius: 20px;
  padding: 5px 10px;
  border: none;
  cursor: pointer;
  font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_LIGHT};
`;
